import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReviewReportGoalFormModel} from '../../models/review.model';
import {EventsService} from '../../../../services/events.service';
import {ControlContainer, NgForm} from '@angular/forms';

@Component({
    selector: 'app-objective-form',
    templateUrl: './objective-form.component.html',
    styleUrls: ['./objective-form.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ObjectiveFormComponent implements OnInit {
    @Input() placeholder: string;
    @Input() groupName: string;
    @Input() disabled = true;

    @Input() title: string;
    @Output() titleChange = new EventEmitter<string>();

    @Input() duration: string;
    @Output() durationChange = new EventEmitter<string>();

    constructor(private event: EventsService) {
    }

    ngOnInit() {
    }

    onTitleChange(value: string) {
        this.event.publish('form:changed', 'review-report');
        this.titleChange.emit(value);
    }

    onDurationChange(value: string) {
        this.event.publish('form:changed', 'review-report');
        this.durationChange.emit(value);
    }
}
